import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { suffixes, ButtonColors } from "../../../constants";

export interface Values {
  firstName: string;
  middleName: string;
  lastName: string;
  suffix: string;
}

interface Props {
  initData?: Values;
  showSuffix?: boolean;
  onSubmit: (formValues: Values) => Promise<boolean>;
  onBack?: () => void;
  buttonColors?: ButtonColors;
}

export const NameFormSimple = ({
  onSubmit,
  onBack,
  initData = { firstName: "", middleName: "", lastName: "", suffix: "" },
  showSuffix = true,
  buttonColors = "primary",
}: Props): JSX.Element => {
  const [values, setValues] = React.useState<Values>(initData);
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);

  return (
    <div>
      <Grid
        container
        spacing={1}
        sx={{
          my: 1,
        }}
      >
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="First name"
            margin="normal"
            name="firstName"
            onChange={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setValues({ ...values, firstName: e.target.value });
            }}
            type="text"
            value={values.firstName}
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Middle name"
            margin="normal"
            name="middleName"
            onChange={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setValues({ ...values, middleName: e.target.value });
            }}
            type="text"
            value={values.middleName}
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Last name"
            margin="normal"
            name="lastName"
            onChange={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setValues({ ...values, lastName: e.target.value });
            }}
            type="text"
            value={values.lastName}
            variant="outlined"
          />
        </Grid>
        {showSuffix && (
          <Grid
            item
            xs={12}
            sx={{
              mt: 2,
            }}
          >
            <FormControl fullWidth>
              <InputLabel id="suffix-label">Suffix</InputLabel>
              <Select
                labelId="suffix-label"
                id="suffix-select"
                value={values.suffix}
                label="Suffix"
                name="suffix"
                onChange={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setValues({ ...values, suffix: e.target.value });
                }}
              >
                {suffixes.map((suffix: string) => (
                  <MenuItem value={suffix} key={`suffix-${suffix}`}>
                    {suffix}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        <Grid item xs={12}>
          <Box sx={{ my: 2 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: onBack ? "row-reverse" : "row",
                justifyContent: "space-between",
              }}
            >
              <Button
                color={buttonColors}
                variant="contained"
                disabled={isSubmitting}
                sx={{ minWidth: 180 }}
                onClick={async () => {
                  setIsSubmitting(true);
                  await onSubmit(values);
                  setIsSubmitting(false);
                }}
              >
                Continue
              </Button>
              {onBack && (
                <IconButton
                  color={buttonColors}
                  disabled={isSubmitting}
                  aria-label="back"
                  onClick={onBack}
                  sx={{ mr: 2 }}
                >
                  <ArrowBackIcon color={buttonColors} />
                </IconButton>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};
